import React, { FC } from 'react';
import { Button, Input, Typography, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { Text } = Typography;

export const parseUserIds = (raw: string): string[] => {
  const seen = new Set<string>();
  raw.split(',').forEach((part) => {
    const id = part.trim();
    if (id) {
      seen.add(id);
    }
  });
  return Array.from(seen);
};

export type UserIdsInputProps = {
  value: string;
  onChange: (raw: string) => void;
};

const UserIdsInput: FC<UserIdsInputProps> = ({ value, onChange }) => {
  const count = parseUserIds(value).length;

  const handleFile = (file: File) => {
    const reader = new FileReader();
    reader.onload = () => onChange(String(reader.result || ''));
    reader.readAsText(file);
    return false; // prevent antd from uploading anywhere
  };

  return (
    <div className="flex flex-col">
      <Input.TextArea
        rows={4}
        value={value}
        placeholder="userId1,userId2,userId3"
        onChange={(e) => onChange(e.target.value)}
      />
      <div className="flex items-center mt-2">
        <Upload accept=".txt" showUploadList={false} beforeUpload={handleFile}>
          <Button icon={<UploadOutlined />}>Select .txt file</Button>
        </Upload>
        <Text className="ml-4" type="secondary">{`${count} user id(s)`}</Text>
      </div>
    </div>
  );
};

export default UserIdsInput;
